import React, { ChangeEvent } from "react";
import {
  Table, Input, Row, Col, Pagination, Button, Spin, notification, Modal, 
  Popconfirm, Breadcrumb, TreeSelect, Select, Space, Empty, ConfigProvider,
  Dropdown,
  Menu,
  Form,
  Upload, 
} from "antd";
import { connect } from "react-redux";
import Column from "antd/lib/table/Column";
import { RootStoreModel } from "../../redux/reducers";
import { Link, RouteComponentProps } from "react-router-dom";
import { BasicStateForListModel } from "../models";
import { CancelTokenSource, IsCancel } from "../../axios/axios.core";
import { getUserList, addUser, deleteUser, importUsers } from "../../axios/api.account";
import { DataNode } from "antd/lib/tree";
import { PlusOutlined,CheckCircleFilled,StopFilled, DownOutlined, UploadOutlined  } from "@ant-design/icons";
import { getOrgsOptionsSelector } from "@redux/selector";

import { Translation } from "react-i18next";
import i18n from "@src/locales";
import zh_CN from "antd/es/locale/zh_CN";
import en_US from "antd/es/locale/en_US";

interface stateModel extends BasicStateForListModel {
  isModalVisible: boolean;
  search: string;
  userId: string;
  userNumber: string;
  userName: string;
  userEmail: string;
  userPhone: string;
  userStatus: "Active" | "Disabled";
  userOrgId: "";
  remark: string;
  orgName: string;
  password: string;
  isMoreModalVisible: boolean,
  file: any,
}

interface propsModel extends RouteComponentProps<any, any, any> {
  orgOptions: DataNode[];
}

const mapStatetoProps = (state: RootStoreModel) => ({
  orgOptions: getOrgsOptionsSelector(state),
});

class UserListPage extends React.Component<propsModel, stateModel> {
  constructor(props: propsModel) {
    super(props);
    this.state = {
      pageIndex: 1,
      pageSize: 10,
      totalCount: 0,
      loading: false,
      columns: [],
      data: [],
      isModalVisible: false,
      search: "",
      userId: "",
      userNumber: "",
      userName: "",
      userEmail: "",
      userPhone: "",
      userStatus: "Active",
      userOrgId: "",
      remark: "",
      orgName: "",
      password: "",
      isMoreModalVisible: false,
      file: ""
    };
  }

  cancelToken = CancelTokenSource();

  componentDidMount() {
    this.getData();
  }

  componentDidUpdate(prevProps: propsModel) { }

  componentWillUnmount() {
    // this.setState = () => { }
    this.cancelToken.cancel("cancel axios http request");
  }

  onSearch = () => {
    this.getData(1);
  };

  getData = (
    pageIndex = this.state.pageIndex,
    pageSize = this.state.pageSize
  ) => {
    const { search } = this.state;
    this.setState({ loading: true });
    getUserList({ pageIndex, pageSize, search }).then((res) => {
      this.setState({
        data: res.dataList,
        loading: false,
        pageSize: res.pageSize,
        pageIndex: res.pageIndex,
        totalCount: res.totalCount,
      });
    });
  };

  onDelete = (id: string) => {
    this.setState({ loading: true });
    deleteUser(id).then(() => {
      notification.success({ message: <Translation>{t => {return t("已删除")}}</Translation> });
      this.setState({ loading: false });
      this.getData(1);
    });
  };

  onOk = () => {
    this.setState({ loading: true });
    const {
      userId,
      userNumber,
      userEmail,
      userName,
      userOrgId,
      userPhone,
      userStatus,
      remark,
      orgName,
      password
    } = this.state;
    console.log(userId);
    addUser({
      id: userId,
      number: userNumber,
      name: userName,
      email: userEmail,
      phone: userPhone,
      organizationName: orgName,
      status: userStatus,
      remark: remark,
      password: password
    }).then(() => {
      notification.success({ message: <Translation>{t => {return t("已提交")}}</Translation> });
      this.setState({ loading: false });
      this.getData(1);
      this.onCancel();
    },()=>{this.setState({ loading: false });}
  );
  };

  onSelectOption = (e: any) => {
    switch (e.key) {
      case "One":
        this.setState({ isModalVisible: true });
        break;
      case "More":
        this.setState({ isMoreModalVisible: true });
        break;
      default:
        break;
    }
  }

  onEdit = (item: any) => {
    const { id, number, email, name, organizationName, phone, remark, password } = item;
    this.setState({
      isModalVisible: true,
      userId: id,
      userNumber: number,
      userEmail: email,
      userName: name,
      orgName: organizationName,
      userPhone: phone,
      remark: remark,
      password: password
    });
  };

  onCancel = () => {
    this.setState({
      isModalVisible: false,
      userId: "",
      userNumber: "",
      userEmail: "",
      userName: "",
      userOrgId: "",
      userPhone: "",
      remark: "",
      password: ""
    });
  };

  uploadFile = (res: any) => {
    const { file } = res;
    this.setState({file: file});
  }

  onEditOk = () => {
    if (!this.state.file) {
      return notification.warning({message: <Translation>{t => {return t("文件不能为空")}}</Translation>})
    }
    this.setState({loading: true});
    importUsers({File: this.state.file}).then(
      () => { notification.success({message: <Translation>{t => {return t("保存成功")}}</Translation>}) },
      () => { notification.error({message: <Translation>{t => {return t("保存失败")}}</Translation>}) }
    ).finally(
      () => { 
        this.setState({loading: false, file: "", isMoreModalVisible: false});
        this.getData(1);
      }
    )
  }
  render() {
    const {
      loading,
      data,
      pageSize,
      pageIndex,
      totalCount,
      isModalVisible,
      userId,
      userNumber,
      userName,
      userEmail,
      userPhone,
      userStatus,
      userOrgId,
      search,
      remark,
      orgName,
      password,
      isMoreModalVisible,
      file
    } = this.state;
    // console.log(columns)
    const { orgOptions } = this.props;
    return (
      (<Translation>{t => {
          return (
            (<div>
              <div className="breadcrumbTop py-2">
                <Breadcrumb>
                  <Breadcrumb.Item>{t("设置")}</Breadcrumb.Item>
                  <Breadcrumb.Item>{t("终端用户")}</Breadcrumb.Item>
                  <Breadcrumb.Item>{t("用户")}</Breadcrumb.Item>
                </Breadcrumb>
                <Row style={{padding: "32px 0 11px 0"}}>
                    <Space>
                        <img src="/images/manageIcon.svg" alt="" />
                        <span style={{display: "flex", fontSize: 22, fontWeight: 500, marginTop: -5}}>{t("用户")}</span>
                    </Space>
                </Row>
              </div>
              <Spin spinning={false}>
                <Row style={{ width: "100%" }}>
                  <div className="borderBox">
                    <Row className="mb-3">
                  
                      <Col>
                      {t("姓名")}:
                        <Input
                          style={{ width: "200px" ,marginLeft:10}}
                          placeholder={t("输入姓名搜索")}
                          value={search}
                          onChange={(e) => this.setState({ search: e.target.value })}
                        ></Input>
                      </Col>

                      <Col offset={1}>
                        <Button type="primary" onClick={() => { this.onSearch(); }}>
                          {t("查询")}
                        </Button>
                      </Col>

                    </Row>
                  </div>
                  <div className="borderBox">
                    <Row style={{marginBottom: 8 }}>
                      <Col className="ms-auto">
                        {/* <Button
                          type="primary"
                          onClick={() => { this.setState({ isModalVisible: true }); }}
                        >
                            <PlusOutlined />
                          {t("添加成员")}
                        </Button> */}
                        <Dropdown
                          popupRender={() => (
                            <Menu onClick={(e) => { this.onSelectOption(e); }}>
                              <Menu.Item key='One'>{t("单个添加")}</Menu.Item>
                              <Menu.Item key='More'>{t("批量添加")}</Menu.Item>
                            </Menu>
                          )}
                          trigger={['click']}
                        >
                          <Button type="primary">
                          {t("添加成员")} <DownOutlined />
                          </Button>
                        </Dropdown>
                      </Col>
                    </Row>
                    <Table
                      size="middle"
                      loading={loading}
                      dataSource={data}
                      pagination={false}
                      onChange={(pagination) => { }}
                      locale={{emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t("暂无数据")}></Empty>}}
                    >
                      <Column
                        key="key"
                        dataIndex="key"
                        title={t("序号")}
                        render={(v, d, i) => i + 1}
                      ></Column>
                      {/* <Column key="number" dataIndex="number" title={t("工号")}></Column> */}
                      <Column key="name" dataIndex="name" title={t("姓名")}></Column>
                      <Column key="email" dataIndex="email" title={t("邮箱")}></Column>
                      <Column key="phone" dataIndex="phone" title={t("电话")}></Column>
                      <Column key="number" dataIndex="number" title={t("工号")}></Column>
                      <Column key="organizationName" dataIndex="organizationName" title={t("部门")}></Column>
                      <Column key="remark" dataIndex="remark" title={t("备注")}></Column>
                      <Column key="sourceType" dataIndex="sourceType" title={t("来源")}
                              render={(v) => (
                                <> 
                                  {v=="Feishu"&&(
                                    <span >{"飞书"}</span>
                                  )}
                                  {v=="Ldap"&&(
                                    <span >{"Ldap"}</span>
                                  )}
                                  {v=="Create"&&(
                                    <span >{"创建"}</span>
                                  )}
                                </>
                              )}
                      ></Column>
                      <Column key="status" dataIndex="status" title={t("状态")}
                              render={(v) => (
                                <> 
                                  {v=="Active"&&(
                                    <span ><CheckCircleFilled  style={{color:"#4CB8BE",fontSize:16}}/>&nbsp;&nbsp;{v}</span>
                                  )}
                                  {v=="Disabled"&&(
                                    <span><StopFilled  style={{color:"#C9A063",fontSize:16}}/>&nbsp;&nbsp;{v}</span>
                                  )}
                                </>
                              )}
                      ></Column>

                      <Column
                        key="operation"
                        dataIndex="id"
                        title={t("操作")}
                        render={(v: string, d: any) => {
                          return (
                            <Space size={8}>
                              <Button disabled={d.sourceType != "Create"} type="link" size="small" onClick={() => { this.onEdit(d); }}>
                                {t("编辑")}
                              </Button>
                              <Popconfirm
                                title={`${t("确认删除")} ${d.name}？`}
                                onConfirm={() => this.onDelete(v)}
                                okText={t("确认")}
                                cancelText={t("取消")}
                                disabled={d.sourceType != "Create"}
                              >
                                <Button disabled={d.sourceType != "Create"} type="link" ghost size="small">
                                  {t("删除")}
                                </Button>
                              </Popconfirm>
                            </Space>
                          );
                        }}
                      ></Column>
                    </Table>
                    <ConfigProvider locale={i18n.language === "zh" ? zh_CN : en_US}>
                      <Pagination
                        style={{ textAlign: "right", marginTop: "20px" }}
                        pageSize={pageSize}
                        current={pageIndex}
                        total={totalCount}
                        showTotal={(total, range) =>
                          `${range[0]}-${range[1]} / ${total} ${t("条")}`
                        }
                        onChange={(page, pageSize) => {
                          this.getData(page, pageSize);
                        }}
                        onShowSizeChange={(current, size) => this.getData(current, size)}
                      ></Pagination>
                    </ConfigProvider>
                  </div>
                </Row>
              </Spin>
              <Modal
                maskClosable={false}
                title={userId ? t("编辑成员") : t("添加成员")}
                width="600px"
                destroyOnClose={true}
                confirmLoading={loading}
                open={isModalVisible}
                onOk={() => this.onOk()}
                onCancel={() => this.onCancel()}
                okText={t("确认")}
                cancelText={t("取消")}
              >
                <Row>
                  {/* <Col span={24} className="mb-2">
                    <label htmlFor="">{t("工号")}</label>
                    <div>
                      <Input
                        placeholder={t("工号")}
                        value={userNumber}
                        onChange={(e) =>
                          this.setState({ userNumber: e.target.value })
                        }
                      ></Input>
                    </div>
                  </Col> */}
                  <Col span={24} className="mb-2">
                    <label htmlFor="">{t("姓名")}</label>
                    <div>
                      <Input
                        placeholder={t("姓名")}
                        value={userName}
                        onChange={(e) => this.setState({ userName: e.target.value.trim() })}
                      ></Input>
                    </div>
                  </Col>
                  <Col span={24} className="mb-2">
                    <label htmlFor="">{t("邮箱")}</label>
                    <div>
                      <Input
                        placeholder={t("邮箱")}
                        value={userEmail}
                        onChange={(e) => this.setState({ userEmail: e.target.value.trim() })}
                      ></Input>
                    </div>
                  </Col>
                  <Col span={24} className="mb-2">
                    <label htmlFor="">{t("电话")}</label>
                    <div>
                      <Input
                        placeholder={t("电话")}
                        value={userPhone}
                        onChange={(e) => this.setState({ userPhone: e.target.value.trim() })}
                      ></Input>
                    </div>
                  </Col>
                  <Col span={24} className="mb-2">
                    <label htmlFor="">{t("工号")}</label>
                    <div>
                      <Input
                        placeholder={t("工号")}
                        value={userNumber}
                        onChange={(e) =>
                          this.setState({ userNumber: e.target.value })
                        }
                      ></Input>
                    </div>
                  </Col>
                  <Col span={24} className="mb-2">
                    <label htmlFor="">{t("密码")}</label>
                    <div>
                      <Input.Password
                        placeholder={t("密码")}
                        value={password}
                        onChange={(e) =>
                          this.setState({ password: e.target.value })
                        }
                      ></Input.Password>
                    </div>
                  </Col>
                  <Col span={24} className="mb-2">
                    <label htmlFor="">{t("部门")}</label>
                    <div>
                      <Input
                        placeholder={t("部门")}
                        value={orgName}
                        onChange={(e) =>
                          this.setState({ orgName: e.target.value.trim() })
                        }
                      ></Input>
                    </div>
                  </Col>
                  <Col span={24} className="mb-2">
                    <label htmlFor="">{t("备注")}</label>
                    <div>
                      <Input
                        placeholder={t("备注")}
                        value={remark}
                        onChange={(e) => this.setState({ remark: e.target.value.trim() })}
                      ></Input>
                    </div>
                  </Col>
                  {/* <Col span={24} className="mb-2">
                    <label htmlFor="">{t("部门")}</label>
                    <div>
                      <TreeSelect
                        style={{ width: "100%" }}
                        placeholder={t("部门")}
                        value={userOrgId}
                        treeData={orgOptions}
                        treeDefaultExpandAll
                        onChange={(v: any) => this.setState({ userOrgId: v })}
                      ></TreeSelect>
                    </div>
                  </Col> */}
                  <Col span={24}>
                    <label htmlFor="">{t("状态")}</label>
                    <div>
                      <Select
                        value={userStatus}
                        onChange={(v) => this.setState({ userStatus: v as any })}
                      >
                        <Select.Option value="Active"> {t("正常")}</Select.Option>
                        <Select.Option value="Disabled"> {t("禁用")}</Select.Option>
                      </Select>
                    </div>
                  </Col>
                </Row>
              </Modal>

              <Modal
                confirmLoading={loading}
                title={t("批量添加成员")}
                width={"50%"}
                open={isMoreModalVisible}
                destroyOnHidden={true}
                maskClosable={false}
                onOk={() => {this.onEditOk()}}
                onCancel={() => {this.setState({isMoreModalVisible: false, file: ""})}}
                okText={t("确认")}
                cancelText={t("取消")}
              >
                <Form style={{lineHeight: "2"}}>
                  <b>{t("操作步骤")}</b>
                  <div>
                    1.<a className="link" href="https://static1.willingtek.com/mdm/user.xls" target="_blank">{t("点击这里")}</a>
                    <span>{t("下载模板")}</span>
                  </div>
                  <Form.Item label={t("2.上传编辑好的模板")}>
                    <Upload
                      accept=".xlsx,.xls"
                      listType="text"
                      showUploadList={true}
                      beforeUpload={() => { return false; }}
                      maxCount={1}
                      onChange={this.uploadFile}
                    >
                      <Button icon={<UploadOutlined />}>{t("上传文件")}</Button>
                    </Upload>
                    {/* <div style={{display: "flex"}}>
                    </div> */}
                  </Form.Item>
                </Form>
              </Modal>
            </div>)
          );
        }}</Translation>)
    );
  }
}

export default connect(mapStatetoProps, {})(UserListPage);
